module.exports = __webpack_public_path__ + "static/media/img.823da79d.png";